import Vue from 'vue'
import Router from 'vue-router'

// 首页
const home = () =>
  import('@/views/home/homePro.vue')
const homeIndex = () => 
  import('@/views/home/index.vue')
// 学习中心
const study = () =>
  import('@/views/study/study.vue')
// 课程
const course = () => import('@/views/course/info.vue')
// 视频
const videoInfo = () => import('@/views/course/videoInfo.vue')
// 影音库
const videoyy = () => import('@/views/videoyy/index.vue')
const videoyyplay = () => import('@/views/videoyy/videoplay.vue')
// 验证码,登录
const loginPage = () => import('@/views/user/loginVerify.vue')
const loginNetCode = () => import('@/views/user/login.vue')
const userInfo = () => import('@/views/user/info.vue')


const indexgw = () => import('@/views/index.vue')

// 全局路由使用
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: indexgw,
      children: [
        {
          path: '/home',
          component: indexgw,
          meta: {
            keepAlive: true
          }
        },
        // {
        //   path: '/userinfo',
        //   name: '用户详情',
        //   component: userInfo
        // },
        // {
        //   path: '/video',
        //   name: '影音库',
        //   component: videoyy,
        //   meta: {
        //     // keepAlive: true
        //   }
        // },
        // {
        //   path: '/course',
        //   name: 'course',
        //   component: course,
        //   meta: {
        //     // keepAlive: true
        //   }
        // },
      ],
      meta: {
        // requireAuth: true, // 判断是否需要登录
      }
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: loginNetCode
    // },
    // {
    //   path: '/videoInfo',
    //   name: 'videoInfo',
    //   component: videoInfo,
    //   meta: {
    //     title: '视频详情',
    //     requireAuth: true, // 判断是否需要登录
    //     // keepAlive: true
    //   }
    // },
    // {
    //   path: '/videoyyplay',
    //   name: 'videoyyplay',
    //   component: videoyyplay,
    //   meta: {
    //     title: '首页',
    //     requireAuth: true, // 判断是否需要登录
    //   }
    // },
    // {
    //   path: '/videoplay',
    //   name: 'videoplay',
    //   component: study,
    //   meta: {
    //     title: '学习中心'
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js